import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';


export namespace ProjectManager {
    /**查询列表 */
    export var GetList = (query:any):Promise<any> =>{
        return Get(`/msls/Project/GetList?${qs.stringify(query)}`,{})
    };
    /**
     * 新增
     */
    export var AddProjectManager = (body:any):Promise<any> =>{
        return Post(`/msls/Project/Add`,body)
    };
    /**
     * 详情
     */
    export var GetProjectDetail = (id:string):Promise<any> =>{
        return Get(`/msls/Project/GetDetail/${id}`,{})
    }
    /**
     * 编辑
     */
    export var EditProject = (id:string,body:any):Promise<any> =>{
        return Put(`/msls/Project/Edit/${id}`,body)
    }
    /**
     * 删除
     */
    export var DelProject = (id:string):Promise<any> =>{
        return Delete(`/msls/Project/Delete/${id}`,{})
    }
    /**
     * 终结
     */
    export var EndProject = (id:string):Promise<any> =>{
        return Put(`/msls/Project/End/${id}`,{})
    }
    /**
     * 完成
     */
    export var finishProject  =(id:string):Promise<any> =>{
        return Put(`/msls/Project/Finish/${id}`,{})
    }
    /**
     * 报表导出
     */
    export var ExportProject = (query:any):Promise<any> =>{
        return Download(`/msls/Project/Export?${qs.stringify(query)}`,{})
    }
    /**
     * 导入模板
     */
    export var ExportGoodsTemplate = ():Promise<any> =>{
        return  Download(`/msls/Inquiry/ExportGoodsTemplate`,{})
    }
    /**
     * 批量导入
     */
    export var ImportGoods = (data):Promise<any> =>{
        return Post(`/msls/Inquiry/ImportGoods`,data)
    }
    /**
     * 发货计划
     */
    export var ProjectOrder = (body:any):Promise<any> =>{
        return Post(`/msls/OrderApi/addOrder`,body)
    }
    /**
     * 项目编号生成询价编号
     */
    export var GetInquiryByProjectCode = (query:any):Promise<any> =>{
        return Get(`/msls/Project/GetInquiryByProjectCode?${qs.stringify(query)}`,{})
    }
    /**启动执行 */
    export var StartProject = (id:string):Promise<any> =>{
        return Put(`/msls/Project/Start/${id}`,{})
    }
}